import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["flow"],
  _excluded2 = ["flow"];
import isEqual from 'hs-lodash/isEqual';
export const isAuditEventTheSame = (longerAuditEvent, shorterAuditEvent) => {
  if (!shorterAuditEvent) return false;
  const longerAuditEventJson = longerAuditEvent.toJSON();

  // @ts-expect-error revisions requires flow, can ignore for these purposes
  longerAuditEventJson.revisions = longerAuditEventJson.revisions.map(rev => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const revWithoutFlow = _objectWithoutPropertiesLoose(rev, _excluded);
    return revWithoutFlow;
  });
  const shorterAuditEventJson = shorterAuditEvent.toJSON();

  // @ts-expect-error revisions requires flow, can ignore for these purposes
  shorterAuditEventJson.revisions = shorterAuditEventJson.revisions.map(rev => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const revWithoutFlow = _objectWithoutPropertiesLoose(rev, _excluded2);
    return revWithoutFlow;
  });
  return isEqual(longerAuditEventJson, shorterAuditEventJson);
};
const compareAuditEvents = (longerAuditEvents, shorterAuditEvents) => longerAuditEvents.findIndex((longerEvent, index) => !isAuditEventTheSame(longerEvent, shorterAuditEvents[index]));
export default compareAuditEvents;